/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_WoodInputs */

const cs_enum_wood = /** @type {(inputs: Enum_WoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dřevostavba`)
};

const en_enum_wood = /** @type {(inputs: Enum_WoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wood`)
};

/**
* | output |
* | --- |
* | "Wood" |
*
* @param {Enum_WoodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_wood = /** @type {((inputs?: Enum_WoodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_WoodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_wood(inputs)
	return cs_enum_wood(inputs)
});